const showAll = { showIcon: true, showWebsite: true, showBlurb: true } as const;
const showNone = {
  showIcon: false,
  showWebsite: false,
  showBlurb: false,
} as const;

export const TIERS = [
  { tier: 'PLATINUM_PARTNERS', label: 'PLATINUM PARTNERS', ...showAll },
  { tier: 'GOLD_PARTNERS', label: 'GOLD PARTNERS', ...showAll },
  { tier: 'SILVER_PARTNERS', label: 'SILVER PARTNERS', ...showAll },
  {
    tier: 'KEY_MIDDLEWARE_PARTNERS',
    label: 'KEY MIDDLEWARE PARTNERS',
    ...showAll,
  },
  { tier: 'CONNECTED_PARTNERS', label: 'CONNECTED PARTNERS', ...showNone },
  { tier: 'CONNECTED_MIDDLEWARE', label: 'CONNECTED MIDDLEWARE', ...showNone },
] as const;
